<template>
    <div class="custom-page-applications" @mousemove="clearTimer">
        <vue-headful :title="$t('check-applications-for-moderator')" />

        <!-- BODY -->
        <div id="algolia-content-container" class="relative clearfix">

            <!--  SIDEBAR  -->

            <vs-sidebar class="items-no-padding"
                        parent="#algolia-content-container"
                        :click-not-close="clickNotClose"
                        :hidden-background="clickNotClose"
                        v-model="isFilterSidebarActive"
                      >

                <component
                        :is="'VuePerfectScrollbar'"
                        ref="filterScroll"
                        class="filters_scroll_area"
                >

                        <div class="p-6 filter-container">
                            <span class="font-bold block mb-4">{{$t('status')}}</span>
                            <ul class="leftx" >
                                <li class="mb-2" v-for="s in status" :key="s.uid" >
                                    <vs-radio
                                    v-model="filters['status']"
                                                vs-name="statuses"
                                                :vs-value="s.uid"
                                    >
                                        {{s.name}}
                                    </vs-radio>
                                </li>
                            </ul>
                            <DatepickerCustom
                                :placeholder="$t('date')"
                                name="date"
                                v-model="filters['created']"
                            />
                        </div>

                </component>
            </vs-sidebar>

            <!--  CONTENT  -->
            <div style="min-height: 60vh" :class="{'sidebar-spacer-with-margin': clickNotClose}">
                <!-- HEADER -->
                    <div class="flex justify-between items-center mb-4">
                        <vs-input v-model.lazy="filters.student"  class="w-10/12" :placeholder="$t('input_write_for_find')"/>
                        <div class="flex flex-wrap">

                            <div>

                                <vx-tooltip :text="isGridView?$t('list'):$t('grid')" position="top" delay=".3s">
                                    <feather-icon
                                        v-if="!windowWidth"
                                        :icon="isGridView?'GridIcon':'ListIcon'"
                                        @click="isGridView=!isGridView"
                                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                                        :svgClasses="{'text-primary stroke-current': currentItemView }" />
                                </vx-tooltip>

                                <feather-icon
                                    v-if="!isFilterSidebarActive"
                                    icon="MenuIcon"
                                    @click.stop="toggleTodoSidebar(true)"
                                    class="ml-2 p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                                    svgClasses="text-primary stroke-current" />
                            </div>
                        </div>
                    </div>

                <!-- LIST WITH TYPE RENDER -->
                <div v-if="histories && histories.length">
                    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4" v-if="currentItemView === 'item-grid-view'">
                        <div v-for="history in histories"
                             class="h-full w-full custom_vx_card"
                             :key="history.uid">
                            <ItemGridView :history="history"  @click="SendPopupData(history)"/>
                        </div>
                    </div>
                    <div v-if="currentItemView === 'item-list-view'">
                        <div v-for="history in histories"
                             class="mb-6"
                             :key="history.uid">
                            <ItemListView  :history="history"   @click="SendPopupData(history)"/>
                        </div>
                    </div>
                </div>

                <div v-else style="height: 100vh">
                    <span class="text-lg">{{ $t('not_result') }}</span>
                </div>
            </div>
        </div>

        <vs-popup title="Установить статус"  :active.sync="popupFormActive" >
            <FormChangeStatus  v-on:close="ClosePopupData" :history="history" v-on:update="getEdvisorHistory"/>
        </vs-popup>

    </div>
</template>

<script>
import DatepickerCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/DatepickerCustom";
import Find from "@/pages/Home/CheckApplicationsForModerator/components/Find";
import ItemGridView from "@/pages/Home/ApplicationHistory/ItemGridView";
import ItemListView from "@/pages/Home/ApplicationHistory/ItemListView";
import FormChangeStatus from './Popup/ChangeStatus'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from '@/configs/Axios'

export default {
    components:{DatepickerCustom,Find,ItemGridView,ItemListView,FormChangeStatus,VuePerfectScrollbar},
    data() {
        return {
            status:[],
            isGridView:true,
            clickNotClose: false,
            isFilterSidebarActive: true,
            page: 1,
            popupFormActive:false,
            filters:{
                created:null,
                student:null,
                status:null,
                lang:'ru'
            },

            countResult: 0,
            histories: [],
            history:{},//это для modal
            updated_time:0,
            updated_time_max:100,
        }
    },
    watch: {
        filters: {
            handler() {
                this.setQueryParams();

                this.getEdvisorHistory()
            },
            deep: true,
        },
        async updated_time(val){
            if(val >= this.updated_time_max){
                await this.clearTimer();
                await this.getEdvisorHistory();
            }
        },
        windowWidth() {
            this.setSidebarWidth();
        },


    },
    computed:{
        lang() {
            return this.$i18n.locale
        },
        windowWidth() {
            return this.$store.state.windowWidth < 992;
        },
        currentItemView(){
            return this.isGridView ? 'item-grid-view':'item-list-view'
        }
    },

    created() {
        var query = this.$route.query
        //взять все данные из ссылки и присвоить в filters если ключи совпадают
        if (Object.keys(query).length) {
            Object.entries(query).filter(([key,val]) =>{
                if(this.filters.hasOwnProperty(key)){
                    this.filters[key] = val
                }
            } );
        }
        this.setSidebarWidth();
        this.timer();
    },
    mounted() {
        this.getEdvisorHistory();
        this.getRequestStatuses();

        this.filters.lang = this.lang
    },
    methods: {
        toggleTodoSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return;
                this.isFilterSidebarActive = value;
        },
        setQueryParams() {
            this.$router.replace({
                name: this.$route.name,
                query: this.filters,
            });
        },

        setSidebarWidth() {
            if (this.windowWidth) {
                this.isFilterSidebarActive = this.clickNotClose = false;
            } else {
                this.isFilterSidebarActive = this.clickNotClose = true;
            }
        },
        SendPopupData(data){
            if(data.status.alias !== "accepted" && data.status.alias !== "declined"){
                this.history = data;
                this.popupFormActive = true
            }
        },
        ClosePopupData(){
            this.history = {};
            this.popupFormActive = false
        },

        async getEdvisorHistory(){
            this.$vs.loading();
            await axios.get(`/organizations/request_advisor/`, { params:this.filters })
                        .then((res)=>{
                            this.histories = res.data.results;
                        })
                        .catch((err)=>{
                            this.$vs.notify({
                                text: this.$t('error'),
                                color: 'danger'
                            })
                        });
            this.$vs.loading.close();

            },

        async getRequestStatuses(){
            this.$vs.loading();

            await axios.get(`/organizations/request_status`)
                    .then((res)=>{
                        this.status = res.data
                    })
                    .catch((err)=>{
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger'
                        })
                    });
            this.$vs.loading.close();

        },

        timer(){
            var self = this;
            setInterval(function(){
                self.updated_time++
            },1000)
        },
        clearTimer(){
            this.updated_time = 0;
        }
    },
}
</script>
